import { css } from '@lastbrand/web-ui-styled-system/css'

// Legacy `mobileOnly` overrides on a desktop default are expressed as Panda's mobile-first
// responsive object form { base, lg } (base = mobile, lg = desktop).

// Base EDD message wrapper. Mirrors .eddMessageWrapper.
export const eddMessageWrapperClass = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'space-4',
  mb: 'space-16',
  color: 'black',
  textStyle: 'body-14',
  lineHeight: '16px', // legacy 1.6rem
  width: { base: '315px', lg: 'auto' }, // fixed mobile width; px literal (no size token)
  textAlign: { base: 'left', lg: 'center' },
  alignItems: { base: 'flex-start', lg: 'center' },
  justifyContent: { base: 'flex-start', lg: 'center' },
})

// .eddMessageWrapper__quickATC override (mobile only)
export const eddMessageWrapperQuickATCClass = css({
  textAlign: { base: 'unset' },
  alignItems: { base: 'start' },
  justifyContent: { base: 'start' },
})

// .eddMessageWrapper_newDesignV2 override (mobile only)
export const eddMessageWrapperNewDesignV2Class = css({
  width: { base: 'full' },
  mb: { base: 'space-16' },
})

// .errorMessageWrapper (unable-to-ship row)
export const errorMessageWrapperClass = css({
  color: 'black',
  flexDirection: 'row',
})

// .errorMessageWrapper__wrapStyling
export const errorMessageWrapperWrapStylingClass = css({
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: 'space-4',
})

// .unableToShipActions__wrapStyling
export const unableToShipActionsWrapStylingClass = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'space-8',
})

// .eddMessageWrapper__callOut (LB_STANDARD_PREMIUM 2-day callout)
export const calloutClass = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  width: 'full',
  textAlign: 'left',
  color: 'black',
  background: 'paperwhite',
  px: { base: 'space-16', lg: 'space-20' },
  py: 'space-20',
  mb: 'space-20',
  textStyle: 'body-14',
})

// .eddMessageWrapper__bold
export const boldClass = css({
  fontWeight: 500,
})

// .eddDefaultContainer (wraps icon + message)
export const eddDefaultContainerClass = css({
  display: 'flex',
  justifyContent: { base: 'flex-start', lg: 'center' },
  alignItems: { base: 'flex-start' },
  gap: { base: 'space-8' },
  // The icon carries `mr: space-8` for the four sites that render it in a plain div; here the
  // container's own `gap` owns the icon↔text spacing, so zero the icon's margin to avoid stacking
  // (gap + mr) into 16px. Legacy parity: `.eddDefaultContainer .messageIcon { margin-right: 0 }`.
  '& > svg': { mr: 0 },
})

// .messageIcon (check icon)
export const messageIconClass = css({
  // `width`/`height` resolve against the `sizes` scale, which has no `space-20` — a spacing token here
  // emits invalid CSS and drops silently. Use a literal so the icon box is actually sized.
  width: '20px',
  height: '20px',
  display: 'inline-block', // legacy icon is inline (vertical-align middle); web-ui icon defaults to block → would stack above the text
  verticalAlign: 'middle',
  mr: 'space-8',
  flexShrink: 0,
})

// .infoIcon — legacy 1.7rem (~17px). No 17px token; keep px.
export const infoIconClass = css({
  width: '17px', // 17px info icon; px literal (no 17px token)
  height: '17px',
  flexShrink: 0,
})

// .eddMessageWithCutoff (desktop flex when cutoff style applies)
export const eddMessageWithCutoffClass = css({
  display: { base: 'block', lg: 'flex' },
})

// .desktopOnlyMsg (the "." separator visible only on desktop in cutoff mode)
export const desktopOnlyMsgClass = css({
  mr: 'space-2',
  display: { base: 'none', lg: 'inline' },
})

// .hideDesktopMsg
export const hideDesktopMsgClass = css({
  display: 'none',
})

// .zipcodeBtnClass__unableToShip — legacy keeps the link text black (`color: inherit`) and only
// the underline grey ($dark-gray-2). Grey just the text-decoration; text stays black.
export const zipLinkUnableToShipCss = css.raw({
  color: 'black',
  textDecorationColor: 'mediumgray',
})

// .zipcodeBtnClass__cutoff offset (object form, merged into TextLink css)
export const zipLinkCutoffCss = css.raw({
  ml: 'space-2',
})

// HolidayMessage row. Mirrors .inStockAndReadyToShipMessage + __holidayMessage.
export const holidayMessageWrapperClass = css({
  color: 'black',
  mt: 0,
  mb: { base: 'space-4', lg: 'space-16' },
  textStyle: 'body-14',
  lineHeight: '16px', // legacy 1.6rem
  textAlign: 'center',
  width: { base: '315px', lg: 'auto' }, // fixed mobile width; px literal (no size token)
})

export const holidayMessageInnerClass = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: { base: 'flex-start', lg: 'center' },
})

export const holidayIconClass = css({
  mr: 'space-6', // legacy 0.5rem (5px) -> nearest token space-6
  // `sizes` scale has no `space-20`; use a literal so the icon box is sized (see messageIconClass).
  width: '20px',
  height: '20px',
  flexShrink: 0,
})
